import * as yup from 'yup';
// import { phoneRegExp } from '../utils'

export const editUserSchema = yup.object({
	name: yup
		.string()
		.required('Please enter email address!'),
    email: yup
		.string()
		.email()
		.required('Please enter email address!'),
	sellerName: yup
		.string(),
	sellerDescription: yup
		.string(),
	sellerLogo: yup
		.string(),
	rating: yup
		.string(),
	numReviews: yup
		.string()
    // phone: yup
	// 	.string()
	// 	.matches(phoneRegExp, 'Phone number is not valid')
	// 	.min(10, "to short")
	// 	.max(10, "to long"),
});
